import { Link } from "react-router-dom";

/**
 * Dashboard / campaign stat tile — navigates to `to` when clicked.
 */
export default function ClickableStatCard({ label, value, suffix = "", Icon, to, accent, testId }) {
  const content = (
    <div
      className={`lift-card p-6 rounded-sm border border-transparent transition-colors h-full ${
        to ? "hover:border-neutral-300 dark:hover:border-neutral-600 cursor-pointer hover:shadow-sm" : ""
      }`}
      data-testid={testId}
    >
      <div className="flex items-center justify-between mb-4">
        <span className="label-overline">{label}</span>
        {Icon && <Icon className="h-4 w-4" style={{ color: accent || "#a3a3a3" }} />}
      </div>
      <div className="font-display font-black tracking-tighter text-3xl lg:text-4xl text-neutral-900 dark:text-neutral-50">
        {value}
        {suffix ? <span className="text-neutral-400 dark:text-neutral-500 text-xl lg:text-2xl font-bold">{suffix}</span> : null}
      </div>
      {to ? <p className="text-xs text-neutral-400 dark:text-neutral-500 mt-3">Click to view →</p> : null}
    </div>
  );
  if (!to) return content;
  return <Link to={to} className="block no-underline text-inherit">{content}</Link>;
}
